/**
 * AttachMenu — botão + menu de anexar arquivos no chat
 * Usado no ChatHubPage (empty state + input bar ativo)
 * Usa tokens do design system
 */
import { T } from '../../styles/tokens';
import { Signal } from '@preact/signals';
import { Ref } from 'preact';

interface AttachMenuProps {
  /** Signal que controla abertura/fechamento do menu */
  menuOpen: Signal<boolean>;
  /** Ref para o input de arquivo (hidden) */
  fileInputRef: Ref<HTMLInputElement>;
  /** Ref para o container do botão (posicionamento) */
  btnRef?: Ref<HTMLDivElement>;
}

export function AttachMenu({ menuOpen, fileInputRef, btnRef }: AttachMenuProps) {
  return (
    <div ref={btnRef} style={{ position: 'relative', flexShrink: 0 }}>
      <button
        onClick={() => { menuOpen.value = !menuOpen.value; }}
        style={{
          width: 32, height: 32, borderRadius: '50%', cursor: 'pointer',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          background: 'transparent', border: 'none', color: T.textSecondary, padding: 0,
        }}
        onMouseEnter={(e: any) => { e.currentTarget.style.color = T.text; }}
        onMouseLeave={(e: any) => { e.currentTarget.style.color = T.textSecondary; }}
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
          <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
        </svg>
      </button>
      {menuOpen.value && (
        <div style={{
          position: 'absolute', bottom: 40, left: 0, background: T.bgInput, borderRadius: 12,
          boxShadow: `0 12px 40px ${T.blackAlpha50}`, border: `1px solid ${T.borderHover}`,
          padding: 4, minWidth: 160, zIndex: 50,
        }}>
          <button
            onClick={() => { menuOpen.value = false; (fileInputRef as any)?.current?.click(); }}
            style={{
              display: 'flex', alignItems: 'center', gap: 10, width: '100%',
              padding: '10px 14px', border: 'none', borderRadius: 8,
              background: 'transparent', color: T.text, fontSize: 13, cursor: 'pointer',
            }}
          >
            Imagem
          </button>
        </div>
      )}
    </div>
  );
}
